// import React from "react";
// import { Star, MapPin, Phone, Navigation } from "lucide-react";

// export default function ProjectDetailsPartTwo({ projectData }) {
//   if (!projectData) {
//     return <div>Loading...</div>;
//   }

//   // Process amenities - API returns array of strings directly
//   const amenities =
//     projectData.amenities && Array.isArray(projectData.amenities)
//       ? projectData.amenities
//       : [];

//   // Process extraFacilities - API returns array of strings directly
//   const extraFacilities =
//     projectData.extraFacilities && Array.isArray(projectData.extraFacilities)
//       ? projectData.extraFacilities
//       : [];

//   // Combine all amenities and facilities
//   const allAmenities = [...amenities, ...extraFacilities];

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 min-h-screen bg-gray-50 ">
//       <div className="w-full bg-white space-y-4 sm:space-y-6 col-span-2 mt-5">
//         <div>
//           <div className="flex items-center gap-2 mb-3 sm:mb-4">
//             <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
//             <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
//               From Our Gallery
//             </h2>
//           </div>

//           {/* Gallery Grid */}
//           <div className="grid grid-cols-2 gap-1.5 sm:gap-2 h-40 sm:h-48 md:h-64 lg:h-80 xl:h-96">
//             <div className="rounded-lg grid grid-cols-1 grid-rows-2 gap-1.5 sm:gap-2">
//               {projectData.images && projectData.images.length > 0 ? (
//                 <>
//                   <div
//                     className="bg-gray-100 rounded-lg bg-cover bg-center"
//                     style={{
//                       backgroundImage: `url(${projectData.images[0] || ""})`,
//                     }}
//                   ></div>
//                   <div
//                     className="bg-gray-200 rounded-lg bg-cover bg-center"
//                     style={{
//                       backgroundImage: `url(${
//                         projectData.images[1] || projectData.images[0] || ""
//                       })`,
//                     }}
//                   ></div>
//                 </>
//               ) : (
//                 <>
//                   <div className="bg-gray-200 rounded-lg"></div>
//                   <div className="bg-gray-200 rounded-lg"></div>
//                 </>
//               )}
//             </div>
//             <div
//               className="bg-gray-200 rounded-lg bg-cover bg-center"
//               style={{
//                 backgroundImage:
//                   projectData.images && projectData.images.length > 2
//                     ? `url(${projectData.images[2]})`
//                     : projectData.images && projectData.images.length > 0
//                     ? `url(${projectData.images[0]})`
//                     : "none",
//               }}
//             ></div>
//           </div>
//         </div>

//         {/* Amenities Section */}
//         {allAmenities.length > 0 && (
//           <div>
//             <div className="flex items-center gap-2 mb-3 sm:mb-4">
//               <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
//               <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
//                 Amenities & Facilities
//               </h2>
//             </div>

//             {/* Amenities Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 sm:gap-3">
//               {allAmenities.map((amenity, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center gap-2 text-xs sm:text-sm text-gray-700"
//                 >
//                   <div className="w-4 h-4 sm:w-5 sm:h-5 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
//                     <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
//                   </div>
//                   <span className="flex-1">{amenity}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Specifications Section */}
//         {projectData.specifications &&
//           projectData.specifications.length > 0 && (
//             <div>
//               <div className="flex items-center gap-2 mb-3 sm:mb-4">
//                 <div className="w-1 h-5 sm:h-6 bg-red-500"></div>
//                 <h2 className="text-base sm:text-lg lg:text-xl xl:text-2xl font-semibold text-gray-800">
//                   Specifications
//                 </h2>
//               </div>

//               <div className="space-y-3 sm:space-y-4">
//                 {projectData.specifications.map((spec, index) => (
//                   <div
//                     key={spec._id || index}
//                     className="bg-gray-200 p-3 sm:p-4 rounded-lg"
//                   >
//                     <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base">
//                       {spec.heading}
//                     </h3>
//                     <ul className="space-y-1">
//                       {spec.subHeadings &&
//                         spec.subHeadings.map((subHeading, subIndex) => (
//                           <li
//                             key={subIndex}
//                             className="text-sm text-gray-600 flex items-center gap-2"
//                           >
//                             <div className="w-1.5 h-1.5 bg-red-500 rounded-full flex-shrink-0"></div>
//                             {subHeading}
//                           </li>
//                         ))}
//                     </ul>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { Phone } from "lucide-react";
import bgimg from "../../Assets/Images/aboutussection/bg1.png";

const ProjectDetailsPartTwo = ({ projectData }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  if (!projectData) {
    return <div>Loading...</div>;
  }

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone) {
      setSubmitMessage("Please fill in all required fields.");
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage("");

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message || "Inquiry about property",
        status: "inquireOn",
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Inquiry submitted successfully:", result);

      setSubmitMessage(
        "Thank you! Your inquiry has been submitted successfully. We'll get back to you soon."
      );

      // Reset form
      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      setSubmitMessage(
        "Sorry, there was an error submitting your inquiry. Please try again later."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Conditional map rendering logic
  const renderMap = () => {
    if (projectData._id === "6891d7342ca72188b0696e57") {
      // Display Covenants La Casa map
      return (
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7485.88152937445!2d85.74821591377254!3d20.261291279676875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a9917c8b6e3b%3A0x5404eed50472a963!2sCovenants%20La%20Casa!5e0!3m2!1sen!2sin!4v1755168163356!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-lg"
        />
      );
    } else {
      // Display Covenants Mi Casa map (default)
      return (
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29941.6966579776!2d85.71593284606932!3d20.270772190889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19a9c79a46e82d%3A0x28d7b3dd6f638b37!2sCovenants%20Mi%20Casa!5e0!3m2!1sen!2sin!4v1755168250732!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-lg"
        />
      );
    }
  };

  return (
    <div className="w-full space-y-6 h-full">
      {/* Inquiry Form */}
      <div className="bg-gray-50 rounded-lg p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Fill up the <span className="text-red-500">Inquiry</span> Form
        </h2>
        <p className="text-gray-600 mb-6 text-sm">
          Let us help you find your dream property. Please fill in the details
          below and our expert will get in touch with you shortly.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
            />
          </div>

          <div>
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white text-sm"
            />
          </div>

          <div>
            <textarea
              name="message"
              placeholder="Message"
              rows="4"
              value={formData.message}
              onChange={handleInputChange}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-colors bg-white resize-none text-sm"
            ></textarea>
          </div>

          {submitMessage && (
            <div
              className={`p-3 rounded-lg text-sm ${
                submitMessage.includes("error") ||
                submitMessage.includes("Sorry")
                  ? "bg-red-100 text-red-700 border border-red-200"
                  : submitMessage.includes("Thank you")
                  ? "bg-green-100 text-green-700 border border-green-200"
                  : "bg-yellow-100 text-yellow-700 border border-yellow-200"
              }`}
            >
              {submitMessage}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full font-semibold py-3 px-6 rounded-lg transition-colors duration-200 text-sm ${
              isSubmitting
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-red-500 hover:bg-red-600 text-white"
            }`}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>

        {/* Phone Contact Section */}
        <div className="mt-8 relative">
          <div
            className="rounded-full px-6 py-4 flex items-center gap-4 text-black font-bold text-lg w-full mx-auto"
            style={{
              backgroundImage: `url(${bgimg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="bg-white rounded-full flex justify-center gap-3 items-center xl:px-2 xl:py-3 lg:py-2 lg:px-2 w-full">
              <div className="bg-white rounded-full w-10 h-10 flex items-center justify-center shadow">
                <Phone className="w-6 h-6 text-black" />
              </div>
              <span className="text-black font-bold xl:text-xl lg:text-md">
                +91 9937003507
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Conditional Map Section */}
      <div className="w-full relative h-64 sm:h-80 md:h-[400px]">
        {renderMap()}
      </div>
    </div>
  );
};

export default ProjectDetailsPartTwo;
